import { all } from 'redux-saga/effects'
import { facebookSagas } from './facebook/facebook.sagas'
import { googleMyBusinessSagas } from './googleMyBusiness/googleMyBusiness.sagas'
import { instagramSagas } from './instagram/instagram.sagas'
import { linkedInSagas } from './linkedIn/linkedIn.sagas'

export function * networkContentRootSagas () {
  yield all([
    facebookSagas(),
    instagramSagas(),
    googleMyBusinessSagas(),
    linkedInSagas()
  ])
}
